import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { defineMessage, useIntl } from '@atlassian/jira-intl';
import { EmptyContentMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/empty-content/index.tsx';

const emptyMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-roadmaps.common.empty-content.no-roadmaps',
	defaultMessage: "Once you open or create roadmap, they'll show up here.",
	description: 'Message for no roadmaps in the roadmaps menu items',
});

export function RoadmapsEmptyContent(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<EmptyContentMenuItem>
			<Text size="small" color="color.text.subtle">
				{formatMessage(emptyMessage)}
			</Text>
		</EmptyContentMenuItem>
	);
}
